if (!customElements.get('pointman-carousel')) {
  class PointmanCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;

      this.viewport = this.querySelector('[data-carousel-viewport]');
      this.track = this.querySelector('[data-carousel-track]');
      this.previousButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));

      if (!this.viewport || !this.track || this.slides.length < 2) return;

      this.dataset.ready = 'true';
      this.paused = false;
      this.resumeTimer = null;

      this.previousButton?.addEventListener('click', () => this.move(-1));
      this.nextButton?.addEventListener('click', () => this.move(1));
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.resume();
      });
      this.viewport.addEventListener('pointerdown', () => this.pauseTemporarily());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.resume();
      });

      this.startAutoplay();
    }

    disconnectedCallback() {
      window.clearInterval(this.autoplayTimer);
      window.clearTimeout(this.resumeTimer);
    }

    get step() {
      const firstSlide = this.slides[0];
      const gap = parseFloat(window.getComputedStyle(this.track).columnGap || 0);
      return firstSlide.getBoundingClientRect().width + gap;
    }

    move(direction) {
      const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
      const target = this.viewport.scrollLeft + this.step * direction;
      let left = target;

      if (direction > 0 && this.viewport.scrollLeft >= maxScroll - 2) left = 0;
      if (direction < 0 && this.viewport.scrollLeft <= 2) left = maxScroll;

      this.viewport.scrollTo({ left, behavior: 'smooth' });
    }

    startAutoplay() {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const enabled = this.dataset.autoplay === 'true';
      if (!enabled || reducedMotion) return;

      const interval = Math.max(Number(this.dataset.interval) || 4500, 2500);
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = window.setInterval(() => {
        if (!this.paused && !document.hidden) this.move(1);
      }, interval);
    }

    pause() { this.paused = true; }
    resume() { this.paused = false; }

    pauseTemporarily() {
      this.pause();
      window.clearTimeout(this.resumeTimer);
      this.resumeTimer = window.setTimeout(() => this.resume(), 5000);
    }
  }

  customElements.define('pointman-carousel', PointmanCarousel);
}
